export default __webpack_public_path__ + "static/81623-991cd8e462a353c5d0156eaa199b779c.jpg";